import { IonContent, IonPage, IonCol, IonRow, IonText, IonGrid, IonList, IonItem, IonLabel, IonCard, IonCardHeader, IonCardTitle, IonInput, IonButton, IonSpinner, useIonViewWillEnter, IonTextarea, IonCheckbox } from '@ionic/react';
import React, { useContext, useRef, useState } from 'react';
import PageHeader from '../../components/PageHeader/PageHeader';
import './FellowshipCreateGroupPage.scss';
import IRouteInfo from '../../interfaces/IRouteInfo';
import ServerDBContext from '../../components/ServerDBContext/ServerDBContext';
import { Redirect, useHistory } from 'react-router-dom';
import { AppRouteInfo, AppRouteKeys } from '../../routes/AppRoutes';
import ReadingPlanRecordService from '../../services/ReadingPlanRecordService';
import NetworkNotification from '../../components/NetworkNotification/NetworkNotification';
import { SelectActiveReadingPlanRecord } from '../../store/BibleStudySlice';
import { useDispatch, useSelector } from 'react-redux';
import { SelectCurrentUser, SelectLoginStatus } from '../../store/UserSlice';
import { UpdateLoadNewGroup } from '../../store/FellowshipSlice';
import UnregisteredUser from '../../data/UnregisteredUser';

const FellowshipCreateGroupPage: React.FC<IRouteInfo> = (props: IRouteInfo) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const LoggedIn = useSelector(SelectLoginStatus);
  const currentUser = useSelector(SelectCurrentUser);
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [groupName, setGroupName] = useState('');
  const [groupDescription, setGroupDescription] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [displayNameValid, setDisplayNameValid] = useState(false);
  const [emailValid, setEmailValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [retypePasswordValid, setRetypePasswordValid] = useState(false);
  const [groupNameValid, setGroupNameValid] = useState(false);
  const [groupDescriptionValid, setGroupDescriptionValid] = useState(false);
  const [sendingMessage, setSendingMessage] = useState('');
  const [redirectToFellowship, setRedirectToFellowship] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const createGroupForm = useRef<HTMLFormElement>(null);
  const dbService = useContext(ServerDBContext);

  useIonViewWillEnter(() => {
    setRedirectToFellowship(false);
    if(currentUser.email !== UnregisteredUser.email) {
      setEmail(currentUser.email ?? '');
      setDisplayName(currentUser.displayName ?? '');
    }
  });

  const createGroup = async(e: React.FormEvent) => {
    e.preventDefault();
    setFormSubmitted(true);

    const validDisplayName = displayName ? true : false;
    const validEmail = email ? true : false;
    const validPassword = password || LoggedIn ? true : false;
    const validRetypedPassword = password === retypePassword || LoggedIn ? true : false;
    const validGroupName = groupName ? true : false;
    const validGroupDescription = groupDescription ? true : false;

    setDisplayNameValid(validDisplayName);
    setEmailValid(validEmail);
    setPasswordValid(validPassword);
    setRetypePasswordValid(validRetypedPassword);
    setGroupNameValid(validGroupName);
    setGroupDescriptionValid(validGroupDescription);

    if(validDisplayName && validEmail && validPassword && validRetypedPassword && validGroupName && validGroupDescription && privacyPolicy) {
      setSendingMessage('Creating New Group');
      const result = await dbService?.createUserAndGroup(email, password, displayName, groupName, groupDescription);
        if(result?.Success) {
          dispatch(UpdateLoadNewGroup(true));
          history.push(AppRouteInfo[AppRouteKeys.Fellowship].path, { direction: 'forward' });
        } else {
          setPassword('');
          setRetypePassword('');
        }
        setSendingMessage(result ? result.Message.UserMessage : '');
    }
  };

  return (
    <IonPage>
      {redirectToFellowship && <Redirect to={AppRouteInfo[AppRouteKeys.Fellowship].path} />}
      <PageHeader {...props} showBackButton={true}></PageHeader>
      <IonContent className="fellowship-content">
        <IonGrid fixed={true}>
          <IonRow >
            <IonCol>
              <IonCard>
                <IonCardHeader color="tertiary" >
                  <IonCardTitle className="ion-text-center">
                    SETUP GROUP
                  </IonCardTitle>
                </IonCardHeader>
                <form ref={createGroupForm} noValidate onSubmit={createGroup}>
                  <IonList className="login-card-fields-list" lines="full">
                    {!LoggedIn && 
                    <IonItem>
                      <IonLabel className="form-label" position="floating">
                        YOUR NAME
                      </IonLabel>
                      <IonInput name="displayName" type="text" value={displayName} spellCheck={false} autocapitalize="off" onIonChange={e => setDisplayName(e.detail.value?.toString()!)}
                        required>
                      </IonInput>
                    </IonItem>}
                    {formSubmitted && !displayNameValid && <IonText color="danger">
                      <p className="ion-padding-start">
                        Your Name is required
                      </p>
                    </IonText>}
                    {!LoggedIn && 
                    <IonItem>
                      <IonLabel className="form-label" position="floating">
                        YOUR EMAIL
                      </IonLabel>
                      <IonInput name="email" type="text" value={email} spellCheck={false} autocapitalize="off" onIonChange={e => setEmail(e.detail.value?.toString()!)}
                        required>
                      </IonInput>
                    </IonItem>}
                    {formSubmitted && !emailValid && <IonText color="danger">
                      <p className="ion-padding-start">
                        Email address is required
                      </p>
                    </IonText>}
                    {!LoggedIn && 
                    <IonItem>
                      <IonLabel className="form-label" position="floating">
                        YOUR PASSWORD
                      </IonLabel>
                      <IonInput name="password" type="password" value={password} onIonChange={e => setPassword(e.detail.value?.toString()!)}>
                      </IonInput>
                    </IonItem>}
                    {!LoggedIn &&
                    <IonItem>
                      <IonLabel className="form-label" position="floating">
                        RETYPE PASSWORD
                      </IonLabel>
                      <IonInput name="retypePassword" type="password" value={retypePassword} onIonChange={e => setRetypePassword(e.detail.value?.toString()!)}>
                      </IonInput>
                    </IonItem>}
                    {formSubmitted && !passwordValid && <IonText color="danger">
                      <p className="ion-padding-start">
                        Password is required
                      </p>
                    </IonText>}
                    {formSubmitted && !retypePasswordValid && <IonText color="danger">
                      <p className="ion-padding-start">
                        Password does not match retyped Password
                      </p>
                    </IonText>}

                    <IonItem>
                      <IonLabel className="form-label" position="floating">GROUP NAME</IonLabel>
                      <IonInput name="groupName" type="text" value={groupName} spellCheck={false} autocapitalize="off" onIonChange={e => setGroupName(e.detail.value?.toString()!)}
                        required>
                      </IonInput>
                    </IonItem>
                    {formSubmitted && !groupNameValid && <IonText color="danger">
                      <p className="ion-padding-start">
                        Group Name is required
                      </p>
                    </IonText>}

                    <IonItem>
                      <IonLabel className="form-label" position="floating">GROUP DESCRIPTION</IonLabel>
                      <IonTextarea name="groupDescription" value={groupDescription} spellCheck={false} autocapitalize="off" onIonChange={e => setGroupDescription(e.detail.value?.toString()!)}
                        required>
                      </IonTextarea>
                    </IonItem>
                    {formSubmitted && !groupDescriptionValid && <IonText color="danger">
                      <p className="ion-padding-start">
                        Group Description is required
                      </p>
                    </IonText>}
                    <div className="policy-terms">
                      <IonCheckbox className="policy-terms-check-box" color="tertiary" checked={privacyPolicy} onIonChange={e => setPrivacyPolicy(e.detail.checked)} ></IonCheckbox>
                      <IonText className="">I agree to this app's <a rel="noreferrer" target="_blank" href="https://biblestudytogether.com/privacy-policy-create-disciples-and-bible-study-together/">Privacy Policy</a> and&nbsp;
                        <a rel="noreferrer" target="_blank" href="https://biblestudytogether.com/app-terms-of-use/">Terms of Use</a>.</IonText>
                    </div>
                    {formSubmitted && !privacyPolicy && <IonText color="danger">
                      <p className="ion-padding-start">
                        Privacy Policy and Terms agreement required
                      </p>
                    </IonText>}
                  </IonList>
                  <IonGrid>
                    <IonRow>
                      <IonCol>
                        <IonButton disabled={sendingMessage === 'Creating New Group'} color="tertiary" type="submit" expand="block">CREATE A GROUP</IonButton>
                      </IonCol>
                    </IonRow>
                    <IonRow>
                      <IonCol>
                        {
                          sendingMessage === 'Creating New Group' ?
                            <IonText className="login-message" color="primary">
                              <IonSpinner name="dots" color="primary" /><br />
                              {sendingMessage}
                            </IonText> :
                            <IonText className="login-message" color="danger">
                              {sendingMessage}
                            </IonText>
                        }
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </form>
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
        <NetworkNotification noInternetMessage="NO INTERNET CONNECTION DETECTED - Connection is required to create a group."></NetworkNotification>
      </IonContent>
    </IonPage>
  );
};

export default FellowshipCreateGroupPage;